/** @format */

if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  $(".sym-slides").slick({
    accessibility: false,
    fade: true,
    infinite: true,
    arrows: false,
  });
  $(".testimonials").slick({
    accessibility: false,
    arrows: true,
    slidesToShow: 1,
  });
  $(".gallery-images").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          variableWidth: true,
        },
      },
    ],
  });
  $(".gallery-line__list").slick({
    arrows: true,
    dots: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
            dots:true,
            arrows:false,  
            slidesToShow: 1,
            slidesToScroll: 1,
        }
      }
    ]
  });

  $(".fancyboxIframe").fancybox({
    maxWidth: 900,
    maxHeight: 600,
    fitToView: false,
    width: "90%",
    height: "90%",
    autoSize: false,
    closeClick: false,
    openEffect: "none",
    closeEffect: "none",
    iframe: {
      scrolling: "auto",
      preload: true,
    },
  });
  //menus
  document.querySelectorAll(".js-menu-tab").forEach((btn) => {
    btn.addEventListener("click", (_) => {
      $(".js-menu-tab.active").removeClass("active");
      $(btn).addClass("active");
      $(".quad-menus__menu-content.active").removeClass("active");
      var tabNumber = $(btn).attr("data-menuid");
      var tabToOpen =
        ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
      $(tabToOpen).addClass("active");
      $(".quad-menus__tabs-image.active").removeClass("active");
      var imgToOpen =
        ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
      $(imgToOpen).addClass("active");
      $(".name-bg.active").removeClass("active");
      var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
      $(wordToOpen).addClass("active");
    });
  });

  //navigate other page menu
  var data = document.URL;
  if ($(".quad-menus").length > 0) {
    var top_col = $(".quad-menus").offset().top;
    data = data.split("?")[1];
    $.each($(".quad-menus__tabs-nav li"), function (index, value) {
      if ($(value).data("menuid") == data) {
        $("html,body")
          .animate({ scrollTop: top_col - 100 }, 1500)
          .delay(1000);
        $(this).click();
      }
    });
  }

  $(".js-slick-prev").click(function () {
    const $curSlider = $(this).data("target")
      ? $($(this).data("target"))
      : $(this).closest(".sym-slides");
    $curSlider.slick("slickPrev");
  });
  $(".js-slick-next").click(function () {
    const $curSlider = $(this).data("target")
      ? $($(this).data("target"))
      : $(this).closest(".sym-slides");
    $curSlider.slick("slickNext");
  });

  // $(window).scroll(function() {
  //     // Setting: Start fading halfway up the page
  //     let startPos = 0.8;

  //     // Cache window object
  //     let $w = $(window);

  //     //find the class scroll-fade
  //     $('.scrollFade').each(function() {

  //         // Get current relative position in viewport, based on the top edge
  //         let pos = ($(this).offset().top + 600) - $w.scrollTop();

  //         // Get viewport height
  //         let vh = $w.height();

  //         if (pos < vh * startPos) {
  //         // If element has past the starting threshold, we fade it
  //             $(this).css('opacity', pos / (vh * startPos) * 1);
  //         } else if((pos - 800) < vh * startPos){
  //             //fade in top element
  //             $(this).css('opacity', (pos - 1500) / (vh * startPos) * -1);
  //         } else {
  //             $(this).css('opacity', 1);
  //         }
  //     });
  // });
})();
